import { createStyles, makeStyles } from '@material-ui/core';

export const useSingleSaleTableItemTypeStyles = makeStyles(() =>
    createStyles({
        default: {
            'backgroundColor': '#FFF8DD',
            '& p': {
                color: '#C18733',
                fontSize: '14px'
            },
            'width': '80px'
        },

        product: {
            'backgroundColor': '#EAB464',
            '& p': { color: '#fff' }
        },

        addOnService: {
            'backgroundColor': '#5E8677',
            '& p': { color: '#FFF' }
        },

        custom: {
            'backgroundColor': '#222222',
            '& p': { color: '#FFF' }
        }
    })
);
